import { render, staticRenderFns } from "./ProfileAuditLogs.vue?vue&type=template&id=f216313e&scoped=true&"
import script from "./ProfileAuditLogs.vue?vue&type=script&lang=js&"
export * from "./ProfileAuditLogs.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAuditLogs.vue?vue&type=style&index=0&id=f216313e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f216313e",
  null
  
)

export default component.exports